import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgIncreasePriceDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m8.058 15 7.579-9.028C16.656 4.758 15.71 3 14.04 3H2.076C.405 3-.54 4.758.48 5.972L8.058 15Z"
      fill="#6ABF40"
    />
  </svg>
);
const Memo = memo(SvgIncreasePriceDown);
export default Memo;
